const api_key = process.env.REACT_APP_API_KEY;

const requests = {
    fetchOriginals: `/discover/tv?api_key=${api_key}&with_networks=213`,
    fetchTrending: `/trending/all/day?api_key=${api_key}&with_networks=213`,
    fetchTopRated: `/movie/top_rated?api_key=${api_key}&with_networks=213`,
    fetchActionMovies: `/discover/movie?api_key=${api_key}&with_genres=28&with_networks=213`,
    fetchComedyMovies: `/discover/movie?api_key=${api_key}&with_genres=35&with_networks=213`,
    fetchHorrorMovies: `/discover/movie?api_key=${api_key}&with_genres=27&with_networks=213`,
    fetchCrimeMovies:`/discover/movie?api_key=${api_key}&with_genres=80&with_networks=213`,
    fetchMysteryMovies:`/discover/movie?api_key=${api_key}&with_genres=9648&with_networks=213`,
    fetchRomanceMovies: `/discover/movie?api_key=${api_key}&with_genres=10749&with_networks=213`,
    fetchAnimationMovies:`/discover/movie?api_key=${api_key}&with_genres=16&with_networks=213`,
    fetchDocumantaries: `/discover/movie?api_key=${api_key}&with_genres=99&with_networks=213`,
    fetchTopRatedtvshow:`/tv/top_rated?api_key=${api_key}&with_networks=213&with_networks=213`,
    fetchPopularmovies:`/movie/popular?api_key=${api_key}&with_networks=213`,
    fetchPopularseries:`/tv/popular?api_key=${api_key}&with_networks=213`,
    fetchActionshows:`/discover/tv?api_key=${api_key}&with_genres=10759&with_networks=213`,
    fetchUpcomingmovies:`/movie/upcoming?api_key=${api_key}&with_networks=213`,
    fetchAnimationshows:`/discover/tv?api_key=${api_key}&with_genres=16&with_networks=213`,
    fetchComedyshows:`/discover/tv?api_key=${api_key}&with_genres=35&with_networks=213`,
    fetchCrimeShows:`/discover/tv?api_key=${api_key}&with_genres=80&with_networks=213`,
    fetchDramaMovies:`/discover/movie?api_key=${api_key}&with_genres=18&with_networks=213`,
    fetchDramaShows:`/discover/tv?api_key=${api_key}&with_genres=18&with_networks=213`,
    fetchFamilyShows:`/discover/tv?api_key=${api_key}&with_genres=10751&with_networks=213`,
    fetchFamilyMovies:`/discover/movie?api_key=${api_key}&with_genres=10751&with_networks=213`,
    fetchRealityShows:`/discover/tv?api_key=${api_key}&with_genres=10764&with_networks=213`,
    fetchRealityMovies:`/discover/movie?api_key=${api_key}&with_genres=10764&with_networks=213`,
    fetchScifimovies:`/discover/movie?api_key=${api_key}&with_genres=878&with_networks=213`,
    fetchScifishows:`/discover/tv?api_key=${api_key}&with_genres=10765&with_networks=213`,
    fetchWarpoliticsshows:`/discover/tv?api_key=${api_key}&with_genres=10768&with_networks=213`,
    fetchWesternshows:`/discover/tv?api_key=${api_key}&with_genres=37`,
    fetchWesternMovies:`/discover/movie?api_key=${api_key}&with_genres=37&with_networks=213`,
    fetchSoapShows:`/discover/tv?api_key=${api_key}&with_genres=10766`,
    fetchHistorymovies:`/discover/movie?api_key=${api_key}&with_genres=36&with_networks=213`,
    fetchThrillermovies:`/discover/movie?api_key=${api_key}&with_genres=53&with_networks=213`,
    fetchFantasyMovies:`/discover/movie?api_key=${api_key}&with_genres=14&with_networks=213`,
    fetchDocumantaryshows:`/discover/tv?api_key=${api_key}&with_genres=99&with_networks=213`,
    fetchWarmovies:`/discover/movie?api_key=${api_key}&with_genres=10752&with_networks=213`,
}

export default requests;